import { AdminDashboardDto, DashboardPeriod } from '@ivy-monorepo/shared'
import { apiClient } from './api-client'

class DashboardService {
  async getDashboard(period?: DashboardPeriod): Promise<AdminDashboardDto> {
    const params = period ? { period } : undefined
    const response = await apiClient.get(`/admin/dashboard`, { params })

    if (!response.data || !response.data.dashboard) {
      throw new Error('Invalid dashboard response format')
    }
    return response.data.dashboard
  }
}

export const dashboardService = new DashboardService()
